module.exports = __webpack_public_path__ + "static/img/7.90cb441.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/7.png
// module id = B3Wb
// module chunks = 0